import { render, staticRenderFns } from "./SiteColumnsLayout.vue?vue&type=template&id=3cfdd31e&scoped=true"
import script from "./SiteColumnsLayout.vue?vue&type=script&lang=js"
export * from "./SiteColumnsLayout.vue?vue&type=script&lang=js"
import style0 from "./SiteColumnsLayout.vue?vue&type=style&index=0&id=3cfdd31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfdd31e",
  null
  
)

export default component.exports